module.exports = __webpack_public_path__ + "static/media/material-cotton.ca635b71.svg";